module.exports = __webpack_public_path__ + "img/38.6.CODm.24f88bf5.png";